const videoGalleryList = document.querySelector('.video-gallery-list');

if (videoGalleryList) {
  const urlParams = ['years', 'locations', 'pageNumber'];

  const getExtraFormDataInput = (parent) => ({
    moduleIndex: parent.querySelector('[data-k]').value,
    years: getCheckedData(parent, 'years'),
    locations: getCheckedData(parent, 'locations'),
    id: localData.id,
  });

  // Filter click
  attachEvent('.video-gallery-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.video-gallery-list');
    const dataPageNumber = parent.querySelector('[data-page-number]');
    if (dataPageNumber) {
      dataPageNumber.setAttribute('data-page-number', 1);
    }

    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.video-gallery-list .video-gallery-list__load-more', 'click', (ev) => {
    const parent = ev.target.closest('.video-gallery-list');
    const dataPageNumber = ev.target.closest('[data-page-number]');
    const currentPage = parseInt(dataPageNumber?.getAttribute('data-page-number'), 10) || 1;
    const nextPage = currentPage + 1;
    dataPageNumber.setAttribute('data-page-number', nextPage);

    axiosGetPaginateAndFilteredPosts(parent, nextPage, urlParams, getExtraFormDataInput(parent), false);
  });
}
